import { Component, OnDestroy, OnInit } from '@angular/core';
import { HelpersService } from 'src/app/shared/services/helpers.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-lumia-chat',
  templateUrl: './lumia-chat.component.html',
  styleUrls: ['./lumia-chat.component.scss']
})
export class LumiaChatComponent implements OnInit, OnDestroy {

  constructor(public helpersService: HelpersService
  ) { }

  ngOnInit(): void {
    if (this.helpersService.isBrowser) {
      document.body.classList.add('cookiebot-zindex-99');
    }
    this.enableLumiaChat();
  }

  ngOnDestroy(): void {
    if (this.helpersService.isBrowser) {
      document.body.className = document.body.className.replace("cookiebot-zindex-99","");
      this.disableLumiaChat();
    }
  }

  private enableLumiaChat(){
    if (this.helpersService.isBrowser) {
      const existLumiaChatScript = document.getElementById("LumiaChatScript") != null;
      if (!existLumiaChatScript) {
        const script = document.createElement('script');          
        script.setAttribute('id','LumiaChatScript');
        script.setAttribute('src',`${environment.lumiaScriptPath}`);
        script.setAttribute('type','text/javascript');
        document.head.appendChild(script);
      }
    }
  }

  private disableLumiaChat(){
    if (this.helpersService.isBrowser) {
      const existLumiaChatScript = document.getElementById("LumiaChatScript");
      const existLumiaChatTag = document.getElementById("lumia-chat-root");
      if (existLumiaChatScript && existLumiaChatTag) {
        existLumiaChatScript.remove(); 
        existLumiaChatTag.remove(); 
      }
    }
  }

}
